export enum FileTypeContentEnum {
	ZPL = "text/plain;charset=utf-8",
	PDF = "application/pdf",
}
